export default function EmailButton() {
  return (
    <a
      href="mailto:cosminmarian.paduraru@gmail.com"
      target="_blank"
      rel="noopener noreferrer"
      className="button-link support"
    >
      ✉️ Support
    </a>
  )
}
